import { render, staticRenderFns } from "./DialogAgreement.vue?vue&type=template&id=12a3e1c3"
import script from "./DialogAgreement.vue?vue&type=script&lang=js"
export * from "./DialogAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports